export default __webpack_public_path__ + "static/media/icono_garantia.50b6db28.svg";